import { Outlet, useNavigate } from 'react-router-dom';
import { useEffect, useContext, Suspense } from 'react';
import { AuthContext } from '../context/user.context';
import NavBar from '../components/navigation-bar/nav-bar.component.developer';
import LoadingScreen from '../components/LoadingScreen';
import { useAppTheme } from '../context/theme.context';

const Developers = () => {
  const { currentUser } = useContext(AuthContext);
  const { colors } = useAppTheme();
  const navigate = useNavigate();
  useEffect(() => {
    if (currentUser === null) {
      navigate('/sign-in');
    }
  }, [currentUser, navigate]);
  return (
    <div style={{ backgroundColor: colors.background.page, minHeight: '100vh' }}>
      <NavBar />
      <Suspense fallback={<LoadingScreen />}>
        <Outlet />
      </Suspense>
    </div>
  );
};

export default  Developers;
